import React, {useState,useEffect} from "react";
import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from '@mui/material'

const TimeSheetConfirmModal = (props) => {
    let [modalStatus, setModal ] = useState(false)
    // console.log('From Timesheet modal confirm ',modalStatus)
    // if(props.type === '')
    let content = null
    let buttonText = 'Yes'
    let headerFontColor = 'black'
    if(props.type === 'LOCK'){
        buttonText = 'Lock'
        content = (
            <div>
                <p style={{marginBottom:0}}>Are you sure you want to lock this timesheet?</p>
                <small>Once the timesheet is set as locked, employees will not be able to edit it</small>
            </div>
        )
    }
    else if (props.type === 'UNLOCK'){
        buttonText = 'Unlock'
        content = (<div>
        <p>Are you sure you want to unlock this timesheet?</p>
        {/* <small>Once the timesheet is set as locked, employees will not be able to edit it</small> */}
    </div>)
    }else if (props.type === 'APPROVE'){
        buttonText = 'Approve'
        headerFontColor = 'green'
       content = ( <div>
        <p>Are you sure you want to approve this timesheet?</p>
        {/* <small>Once the timesheet is set as locked, employees will not be able to edit it</small> */}
    </div>)
    }else if (props.type === 'UNAPPROVE'){
        buttonText = 'Unapprove'
        headerFontColor = 'red'
       content = ( <div>
        <p>Are you sure you want to unapprove this timesheet?</p>
        {/* <small>Once the timesheet is set as locked, employees will not be able to edit it</small> */}
    </div>)
    }else {
        content = (
            <div>
                <p>Are you sure you want to {props.status === "SUBMITTED" ? "reject" : "submit"} this timesheet?</p>
            </div>
        );
    }


    return (
        <div 
        onClick={()=> {
            if(!props.disabled){
                setModal(!modalStatus)}
            }
        }
        >
            {props.children}
             <Dialog open={modalStatus} onClose={()=> setModal(false)}>
                        <DialogTitle sx={{textAlign: 'center', color: headerFontColor}}>
                            {props.type === 'LOCK'? 
                        'LOCK TIMESHEET':props.type === 'UNLOCK'?
                        'UNLOCK TIMESHEET':props.type === 'APPROVE'?'APPROVE TIMESHEET':props.type === 'UNAPPROVE'?'UNDO APPROVE': (props.status === "SUBMITTED" ? "REJECT" : "SUBMIT") + ' TIMESHEET'}
                        </DialogTitle>
                        <DialogContent sx={{textAlign: 'center'}}>
                            {content}
                        </DialogContent>
                        <DialogActions sx={{justifyContent: 'center', margin: 2}}>
                        <Button variant="outlined" onClick={()=> setModal(false)}>
                            Back
                        </Button>
                        <Button sx={{marginLeft: 1}} variant="contained" onClick={async()=> { 
                            await props.onClick()
                            setModal(false)
                            }
                        }
                        >
                            {buttonText}
                        </Button>
                        </DialogActions>
                    </Dialog>
                   
        {/* {props.children} */}
        </div>
    )
}

export default TimeSheetConfirmModal